import React from "react"
import PropTypes from "prop-types"
import Grid from "./Grid"
import Date from "./Date"

export default class QuestionnaireResponse extends React.Component {
    static propTypes = {
        resources: PropTypes.arrayOf(PropTypes.object).isRequired,
        settings: PropTypes.object,
        type: PropTypes.string
    };

    // Convert QuestionnaireResponse.items into table rows
    getRows(resource) {
        if (!resource || !resource.item) return [];

        const authored = resource.authored || "--";

        // Only include items that have extension
        const itemsWithExtension = resource.item.filter(
            it => Array.isArray(it.extension) && it.extension.length > 0
        );

        return itemsWithExtension.map(it => ({
            question: it.text || "--",
            answer: it.answer?.[0]?.valueString || "--",
            authored
        }));
    }


    render() {
        const recs = this.props.resources || [];
        let rows = [];

        // Flatten all QuestionnaireResponses into rows
        recs.forEach(r => {
            rows = rows.concat(this.getRows(r.resource));
        });

        const columns = [
            {
                label: "Question",
                render: o => o.question
            },
            {
                label: "Answer",
                render: o => o.answer
            },
            {
                label: "Authored",
                render: o => o.authored === "--"
                    ? "--"
                    : <Date moment={o.authored} />
            }
        ];

        return (
            <Grid
                rows={rows}
                cols={columns}
                title={`Questionnaire Responses (${rows.length})`}
            />
        );
    }
}
